import React from "react";

const FormSection = props => {
  const {children, title, show, action, actionContent, sectionId, tabindex} =
    props;

  return (
    show && (
      <div id={sectionId || ""} tabIndex={tabindex || ""} className="row mb-5">
        <div className="col-12">
          <div className="d-flex align-items-center">
            <h5 className="text-blue-cermaq my-4">{title}</h5>
            {action && (
              <button
                type="button"
                className="btn bg-primary text-white ms-auto d-flex align-items-center"
                onClick={() => action()}
              >
                {actionContent}
              </button>
            )}
          </div>
        </div>
        <div className="col-12">
          <div className="border rounded-3 p-3">{children}</div>
        </div>
      </div>
    )
  );
};

export default FormSection;
